import json from './header.json'
export default {
  lang: {
    zh: '中文',
    en: 'English',
  },
  ...json
  // header
}
